
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { CurrentGoalNumbers, KpiRequest } from '../models/kpi.model';



@Injectable()
export class KpiService {
  constructor(private http: HttpClient) { }

  sendKpiEmail(
    data: KpiRequest,
    newCustomersWidth: { current: number, goal: number },
    itaNewMrrDirectWidth: { current: number, goal: number },
    itaNewMrrIndirectWidth: { current: number, goal: number }
  ) {
    return this.http.post(
      environment.kpiEmail,
      JSON.stringify({ ...data, newCustomersWidth, itaNewMrrDirectWidth, itaNewMrrIndirectWidth })
    );
  }


  calculateWidth(current: number, goal: number): CurrentGoalNumbers {
    const curr: number = 100 * (Number(current) / Number(goal)) || 0;
    return {
      current: curr,
      goal: 100 - (Number(curr) || 0)
    };
  }


  getTemplateCode(data: KpiRequest): string {
    // const ukNewMrrDirectWidth = calculateWidth(data.ukNewMrrDirectCurrent, data.ukNewMrrDirectGoal);
    // const usaNewMrrDirectWidth = calculateWidth(data.usaNewMrrDirectCurrent, data.usaNewMrrDirectGoal);


    return `
              <table border="0" align="center" cellpadding="0" cellspacing="0"
                style="max-width:670px; background:#fff; border-radius:3px;-webkit-box-shadow:0 6px 18px 0 rgba(0,0,0,.06); -moz-box-shadow:0 6px 18px 0 rgba(0,0,0,.06); box-shadow:0 6px 18px 0 rgba(0,0,0,.06); padding:0 40px;">
                <tr>
                  <td style="height:40px;">&nbsp;</td>
                </tr>
                <!-- Title -->
                <tr>
                  <td style="padding:0 15px; text-align:center;">
                    <h1 style="color:#000; font-weight:400; margin:0; font-size:32px;">
                      VOXLOUD KPIs - ${data.kpiMonth} ${data.kpiYear}</h1>
                    <span style="display:inline-block; vertical-align:middle; margin:29px 0 26px; border-bottom:1px solid #e5e9f0; width:100px;"></span>
                  </td>
                </tr>
                <!-- Reports -->
                <tr>
                  <td style="text-align:center;">
                    <table cellpadding="0" cellspacing="0" style="min-width:600px; width: 100%; border:1px solid #e5e9f0;">
                        <tbody>
                            <tr>
                                <td style="padding: 20px 0; vertical-align: top;">
                                    <div style="min-height: 78px; border-right: 1px solid #e5e9f0; padding:0 5px;">
                                        <span style="display:block; font-size:30px; font-weight:700; color:#000; text-align:center; margin-bottom:5px;">${data.totalCustomers}</span>
                                        <span style="display:block; font-size:16px; font-weight:300; color:#868990; text-align:center;">Total Paying<br> customers</span>
                                    </div>
                                </td>
                                <td style="padding: 20px 0; vertical-align: top;">
                                    <div style="min-height: 78px; border-right: 1px solid #e5e9f0; padding:0 5px;">
                                    <span style="display:block; font-size:30px; font-weight:700; color:#000; text-align:center; margin-bottom:5px;">€${data.mrr}</span>
                                    <span style="display:block; font-size:16px; font-weight:300; color:#868990; text-align:center;">MRR</span>
                                    </div>

                                </td>
                                <td style="padding: 20px 0; vertical-align: top;">
                                    <div style="min-height: 78px; border-right: 1px solid #e5e9f0; padding:0 5px;">
                                    <span style="display:block; font-size:30px; font-weight:700; color:#000; text-align:center; margin-bottom:5px;">${data.mrrGrowth}%</span>
                                    <span style="display:block; font-size:16px; font-weight:300; color:#868990; text-align:center;">Net MRR growth</span>
                                    </div>

                                </td>
                                <td style="padding: 20px 0; vertical-align: top;">
                                    <div style="min-height: 78px; padding:0 5px;">
                                    <span style="display:block; font-size:30px; font-weight:700; color:#000; text-align:center; margin-bottom:5px;">${data.paidSubscriptionChurn}%</span>
                                    <span style="display:block; font-size:16px; font-weight:300; color:#868990; text-align:center;">Paid Subscription<br> churn</span>
                                    </div>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span style="display:inline-block; vertical-align:middle; margin:29px 0 26px; border-bottom:1px solid #e5e9f0; width:100px;"></span>
                  </td>
                </tr>
                <!-- Details Table -->
                <tr>
                  <td>
                    <table cellpadding="0" cellspacing="0" style="min-width:600px; width: 100%; border:1px solid #e5e9f0;">
                      <tbody>
                        <tr>
                          <td
                            style="padding:10px; border-bottom:1px solid #ededed; line-height: 1; border-right:1px solid #ededed; width:35%; font-weight:500; color:#868990;">
                            <img style="height:14px; width:14px; vertical-align:middle; margin-right:5px;" src="https://www.voxloud.com/it/wp-content/themes/voxloud/dist/img/globe.png" alt="Globe icon">New customers:</td>
                          <td style="padding:10px; border-bottom:1px solid #ededed; color:#868990;">
                            <table cellpadding="0" cellspacing="0" width="100%" style="margin-bottom:10px;">
                              <tr>
                                <td style="background-color:#ff3465;" width="${data.newCustomersWidth.current}%">
                                </td>
                                <td height="40" style="min-height:40px; font-size:0; background-color:#eeeeee;" width="${data.newCustomersWidth.goal}%">
                                  &nbsp;
                                </td>
                              </tr>
                            </table>
                            ${data.newCustomersCurrent || 0} (of ${data.newCustomersGoal || 0} reached)
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="padding:10px; border-bottom:1px solid #e5e9f0; border-right:1px solid #e5e9f0; width:35%; font-weight:500; color:#868990">
                            <img style="height:14px; width:14px; vertical-align:middle; margin-right:5px;" src="https://www.voxloud.com/it/wp-content/themes/voxloud/dist/img/flag-italy.png" alt="ITA flag">ITA Net new MRR (direct):</td>
                          <td style="padding:10px; border-bottom:1px solid #e5e9f0; color: #868990;">
                            <table cellpadding="0" cellspacing="0" width="100%" style="margin-bottom:10px;">
                              <tr>
                                <td height="40" style="background-color:#ff3465;" width="${data.itaNewMrrDirectWidth.current}%">
                                </td>
                                <td height="40" style="background-color:#eeeeee; font-size:0; color:#868990;" width="${data.itaNewMrrDirectWidth.goal}%">
                                  &nbsp;
                                </td>
                              </tr>
                            </table>
                            ${data.itaNewMrrDirectCurrent || 0}€ (of ${data.itaNewMrrDirectGoal || 0}€ reached)
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="padding:10px;  border-bottom:1px solid #e5e9f0; border-right:1px solid #e5e9f0; width:35%; font-weight:500; color:#868990;">
                            <img style="height:14px; width:14px; vertical-align:middle; margin-right:5px;" src="https://www.voxloud.com/it/wp-content/themes/voxloud/dist/img/flag-italy.png" alt="ITA flag">ITA Net new MRR (indirect):</td>
                          <td style="padding:10px; border-bottom:1px solid #e5e9f0; color:#868990;">
                            <table cellpadding="0" cellspacing="0" width="100%" style="margin-bottom:10px;">
                              <tr>
                                <td style="background-color:#ff3465;" width="${data.itaNewMrrIndirectWidth.current}%">
                                </td>
                                <td height="40" style="background-color:#eeeeee; font-size:0; color:#868990;" width="${data.itaNewMrrIndirectWidth.goal}%">
                                  &nbsp;
                                </td>
                              </tr>
                            </table>
                            ${data.itaNewMrrIndirectCurrent || 0}€ (of ${data.itaNewMrrIndirectGoal || 0}€ reached)
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="height:20px;">&nbsp;</td>
                </tr>
                <tr>
                    <td>
                        <p style="line-height:30px; font-size:20px; color:#868990; margin: 0;">
                            <b style="display: block; color: #868990;">Quote of the month:</b>
                            ${data.quote}</p>
                    </td>
                </tr>
                <tr>
                    <td style="height:40px;">&nbsp;</td>
                </tr>
              </table>`;
  }

}
